import Routers from './router'
import mysaleStore from './store'
export default{
	install(Vue,{router,store}){
		router.addRoute(Routers);
		store.registerModule('distributionMudule', mysaleStore)
	}
}